import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Form, Button } from "react-bootstrap";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

import {
  InputLabel,
  TextField,
  FormControl,
  Select,
  MenuItem,
  makeStyles,
} from "@material-ui/core";
import { useFormik } from "formik";
import * as yup from "yup";
import isEmpty from "../../../../store/validation/is-Empty";
import { admin_add_money_departmental_wallet } from "../../../../store/actions/SuperAdminActions/superAdminWalletAction";
import { SmallLoader } from "../../../Loader/SmallLoader";
import { errorAlert } from "../../../../function/alert";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

function SuperAdminDepartmentalWalletAdd(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [state, setState] = useState(0);

  const token = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth : "";
  });

  const formik = useFormik({
    initialValues: {
      credit: true,
      balance: "",
      departmentalCode: "SP101",
      reason: "",
      comment: "",
      notify: false,
    },
    validationSchema: yup.object({
      balance: yup.string().required("Amount is required"),
      departmentalCode: yup.string().required("Departmental Code is required"),
      reason: yup.string().required("Reason is required"),
      comment: yup.string().required("Comment is required"),
    }),

    onSubmit: (values) => {
      var formData = {};
      formData.credit = values.credit;
      formData.balance = values.balance;
      formData.departmentalCode = values.departmentalCode;
      formData.reason = values.reason;
      formData.comment = values.comment;
      formData.notify = values.notify;
      dispatch(
        admin_add_money_departmental_wallet(
          token.user.accessToken,
          formData,
          onSuccess,
          onError
        )
      );
    },
  });

  const onSuccess = () => {
    history.push("/superadmin/departmentwallet/addremovemoneyrequest");
  };

  const onError = (err) => {
    errorAlert(err || "Something went wrong, try again later")
  }

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  // for set focus
  useEffect(() => {
    if (formik.errors && formik.errors.balance) {
      let balanceElement = document.getElementById("balance");
      balanceElement.focus();
    } else if (formik.errors && formik.errors.reason) {
      let reasonElement = document.getElementById("reason");
      reasonElement.focus();
    } else if (formik.errors && formik.errors.departmentalCode) {
      let departmentalCodeElement = document.getElementById("departmentalCode");
      departmentalCodeElement.focus();
    } else if (formik.errors && formik.errors.comment) {
      let commentElement = document.getElementById("comment");
      commentElement.focus();
    }
  }, [count]);

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            {token.secondary_loader ? (
              <SmallLoader />
            ) : (
              <div className="super-admin-inside-right-side-panel">
                <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                  <div className="f24_700_HelveticaNeue">
                    Add Money to Departmental Wallet
                  </div>
                </div>

                <div className="row">
                  <div className="col-5 mt-2">
                    {/* <NewInputText labelText="Enter Amount" type="text" /> */}
                    <Form.Group>
                      <TextField
                        id="balance"
                        label="Enter Amount"
                        type="number"
                        variant="outlined"
                        className={`w-100 ${
                          formik.errors.balance && formik.touched.balance
                            ? "enError"
                            : ""
                        }`}
                        onInput={(e) => {
                          e.target.value = Math.max(0, parseInt(e.target.value))
                            .toString()
                            .slice(0, 5);
                        }}
                        name="balance"
                        onChange={formik.handleChange}
                        value={formik.values.balance}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.balance && formik.touched.balance ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.balance}
                        </div>
                      ) : null}
                    </Form.Group>
                    <div
                      className="f12-400 mt-2 mb-4"
                      style={{ color: "#9E9E9E" }}
                    >
                      *The maximum amount limit will be ₹ 10,000/-
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-5 mt-2">
                    <Form.Group>
                      <TextField
                        id="departmentalCode"
                        label="Department Code"
                        type="text"
                        variant="outlined"
                        className={`w-100 ${
                          formik.errors.departmentalCode &&
                          formik.touched.departmentalCode
                            ? "enError"
                            : ""
                        }`}
                        inputProps={{
                          maxLength: 32,
                        }}
                        name="departmentalCode"
                        onChange={formik.handleChange}
                        value={formik.values.departmentalCode}
                        onBlur={formik.handleBlur}
                        disabled={true}
                      />
                      {formik.errors.departmentalCode &&
                      formik.touched.departmentalCode ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.departmentalCode}
                        </div>
                      ) : null}
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-5 mt-2">
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <InputLabel htmlFor="outlined-time">
                        Add Reason
                      </InputLabel>
                      <Select
                        value={formik.values.reason}
                        onChange={formik.handleChange}
                        label="Reservation Time"
                        inputProps={{
                          name: "reason",
                          id: "outlined-time",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <MenuItem value="" disabled selected>
                          Select Reason
                        </MenuItem>
                        <MenuItem value={"Amount"}>Amount</MenuItem>
                      </Select>
                      {formik.errors.reason && formik.touched.reason ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.reason}
                        </div>
                      ) : null}
                    </FormControl>
                  </div>
                </div>
                <div className="row">
                  <div className="col-5 mt-4">
                    <Form.Group>
                      <TextField
                        id="comment"
                        label="Add Comments"
                        type="text"
                        variant="outlined"
                        multiline
                        rows={4}
                        className={`w-100 ${
                          formik.errors.comment && formik.touched.comment
                            ? "enError"
                            : ""
                        }`}
                        inputProps={{
                          maxLength: 512,
                        }}
                        name="comment"
                        onChange={formik.handleChange}
                        value={formik.values.comment}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.comment && formik.touched.comment ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.comment}
                        </div>
                      ) : null}
                    </Form.Group>
                  </div>{" "}
                </div>
                <div className="row">
                  {" "}
                  <div className="col-5 mt-2">
                    <div className="d-flex align-items-center pt-4">
                      <Button
                        variant="outline-secondary"
                        className="btn150px btn-lg mr-4 px-5"
                        type="button"
                        onClick={() =>
                          history.push("/superadmin/departmentwallet")
                        }
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="danger"
                        className="btn150px btn-lg px-5"
                        type="button"
                        onClick={() => onClickSave()}
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default SuperAdminDepartmentalWalletAdd;
